"use client"

interface Skill {
  name: string
  percentage: number
}

interface SkillTrackerProps {
  skills: Skill[]
}

export function SkillTracker({ skills }: SkillTrackerProps) {
  return (
    <div className="bg-slate-100 p-6 sm:p-8 rounded-2xl shadow-lg">
      <div className="flex items-center gap-4 mb-6 bg-slate-100">
        <div className="p-3 bg-slate-200 rounded-full bg-white">
          <span className="text-slate-200">📈</span>
        </div>
        <h2 className="text-2xl font-bold text-slate-900">Skill Development Tracker</h2>
      </div>

      <div className="space-y-6 bg-slate-100">
        {skills.map((skill) => (
          <div key={skill.name}>
            <div className="flex justify-between items-center mb-1 bg-slate-100">
              <span className="text-base font-medium text-slate-700">{skill.name}</span>
              <span className="text-sm font-medium text-blue-600 ">{skill.percentage}%</span>
            </div>
            <div className="w-full bg-slate-100 rounded-full h-2.5">
              <div
                className="bg-blue-600 h-2.5 rounded-full transition-all duration-300"
                style={{ width: `${skill.percentage}%` }}
              />
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}
